module.exports = __webpack_public_path__ + "static/media/3020.c328b595.jpg";